import { Collapse, Select } from 'antd';
import { SelectProps } from 'antd/es/select';
import styled from 'styled-components';

export const Title = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  padding: 16px 24px 16px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.16px;
`;

export const StyledCollapse = styled(Collapse)`
  &&.emp-ant-collapse .emp-ant-collapse-item {
    display: flex;
    flex-direction: column;
    gap: 8px;

    padding: 16px 24px 16px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0;

    .emp-ant-collapse-header {
      padding: 0;
      align-items: center;
    }

    .emp-ant-collapse-content .emp-ant-collapse-content-box {
      padding: 0;
      padding-block: 0;
    }
  }
`;

export const CollapseHeader = styled.div`
  color: rgba(0, 0, 0, 0.88);
  font-weight: 500;
  letter-spacing: -0.14px;
`;

export const EventJourneySelect = styled(Select)<SelectProps<any>>`
  &.emp-ant-select {
    .emp-ant-select-selector {
      color: #0046ff;
    }
  }
`;
